export type SearchParams = Record<string, unknown>;

function isNested(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}

function appendParam(query: URLSearchParams, key: string, value: unknown): void {
  if (value === undefined) return;

  if (Array.isArray(value)) {
    value.forEach((item, index) => appendParam(query, `${key}[${isNested(item) ? index : ''}]`, item));
    return;
  }

  if (isNested(value)) {
    Object.entries(value).forEach(([nestedKey, nestedValue]) =>
      appendParam(query, `${key}[${nestedKey}]`, nestedValue),
    );
    return;
  }

  query.append(key, value === null ? '' : String(value));
}

// Формат jQuery.param (PHP-стиль), которого ждёт api-gateway: массивы скаляров — `key[]=v`,
// массивы объектов — `key[0][field]=v`, вложенные объекты — `key[field]=v`.
// Не qs: ни один его arrayFormat не даёт одновременно `[]` для скаляров и `[i]` для объектов.
export function serializeSearchParams(params: SearchParams): string {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => appendParam(query, key, value));

  return query.toString();
}
